export const environment = {
  recaptcha: {
    siteKey: '6LfBmzsaAAAAAM1O1zHzwTESD51CyI6EZ0N4DQJ2',
  },
  production: true,
  version: require('../../package.json').version,
  commitHash: require('../../COMMIT_ID.json').commitId,
  api: {
    baseUrl: 'https://cnl.qualitel.delivery.trsb.net/api/',
    adresseUrl: 'https://data.geopf.fr/geocodage/search/',
    authentication: {
      client_id: 'f8c2d80d-6048-4537-b439-c5c85e6fcd20',
      client_secret: '63aCji1KqJ4UOjNSCNrr'
    }
  },
  matomo: {
    siteId : 17,
    url : 'https://qualitel.matomo.cloud/',
    enabled: false
  },
  rt2012: {
    enedis: {
      enedisConsentUrl: 'https://clea.qualitel.local/pro/enedis',
      deleteAccessToken: 'pro/enedis/delete-token'
    },
    grdf: {
      grdfConsentUrl: 'https://clea.qualitel.local/pro/grdf-adict',
      deleteGrdfToken: 'pro/grdf-adict/delete-token'
    }
  },
  homadata: {
    key: 'b2f00474da1c5554ed08b69607a84f5896e66c26'
  },
  logoutUrl: 'https://cnl.qualitel.delivery.trsb.net/logout',
  baseUrlBack: 'https://cnl.qualitel.delivery.trsb.net/',
  bdnbUrl: 'https://api.bdnb.io/v1/bdnb/',
  envName: '',
  GA_ID: '',
  SonergiaPartnerId: 3,
  SonergiaPartnerJuraId: 1813,
  SonergiaPartnerLandesId: 1812,
  enableParcoursTravaux: true,
};
